<template>
  <div>
    <Schedule
      v-if="$route.query.organizationSchedule"
      class="mb-2"
    />
    <v-alert
      dense
      elevation="0"
      v-else-if="$route.query.OTError"
      class="mb-0 px-0"
    >
      <div class="d-flex">
        <Icon
          :width="30"
          class="mr-3"
          :color="'rgba(0,0,0,.54)'"
          :icon="'alert-circle-outline'"
        />
        {{ widgetContent.otError }}
      </div>
    </v-alert>
    <v-alert
      dense
      elevation="0"
      v-else
      class="mb-0 px-0"
    >
      <div class="d-flex">
        <Icon
          :size="30"
          class="mr-3"
          :color="'rgba(0,0,0,.54)'"
          icon="account-cancel-outline"
        />
        {{ widgetContent.noCammersConnected }}
      </div>
    </v-alert>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Schedule: () => import(/* webpackPrefetch: true */ '@/views/lobby/resources/ScheduleOrganization.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  computed: {
    widgetContent () {
      const attr = this.$organization.widgetContent()

      return {
        isActive: attr.isActive,
        otError: attr.data?.lobby?.ot_error ?? this.$t('detail.otError'),
        noCammersConnected: attr.data?.lobby?.no_cammers_connected ?? this.$t('detail.noCammersConnected')
      }
    }
  }
})
export default class Detail extends Vue {}
</script>

